module.exports = __webpack_public_path__ + "img/icon-pro.d2e6b535.png";